import {BUTTON_SETTINGS_ACTION, ButtonSettingsAction} from '../action/button-settings.action';
import {IButtonSettingsState} from '../state/button-settings.state';

const initialButtonSettingsState: IButtonSettingsState = {
  accessibility_link_enabled: '',
  accessibility_link_text: '',
  accessibility_url: '',
  site_id: 0,
  site_name: '',
  widget_color: '',
  widget_color_gradient: '',
  widget_hidden_for_site: '',
  widget_hidden_for_mobile: false,
  widget_sounds: true,
  widget_icon_size: 'large',
  widget_icon_type: '',
  widget_language: '',
  widget_position: '',
  widget_position_mobile: '',
  widget_custom_trigger: null,
  widget_custom_trigger_enabled: false,
  host: '',
};

export function buttonSettingsReducer(
  state: IButtonSettingsState = initialButtonSettingsState,
  action: ButtonSettingsAction,
): IButtonSettingsState {
  switch (action.type) {
    case BUTTON_SETTINGS_ACTION.INIT_BUTTON_SETTINGS:
      return {
        ...state,
        ...action.payload,
      };
    case BUTTON_SETTINGS_ACTION.RESET_BUTTON_SETTINGS:
      return initialButtonSettingsState;
    default:
      return state;
  }
}
